<template>
  <DBox
    :id="'cmp-distribution-accounts-account_sidewindow-cost-list'"
    :addButton="false"
    :addLink="false"
  >
    <NTable
      class="dbox1"
      :id="'cmp-distribution-accounts-account_sidewindow-cost-list'"
      :headers="headers"
      :items="list"
      :config="tableConfig"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('main_costs')">
            <span
              @click.stop="(e) => onRowClicked(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['external_ref']"
            >
              {{ item["external_ref"] }}
            </span>
          </td>
          <td v-bind="tdcon('creditor')">
            <span class="txtov" :title="item['full_name']">
              {{ item["full_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('date')">
            <span class="txtov" :title="item['invoice_date']">
              {{ item["invoice_date"] }}
            </span>
          </td>
          <td v-bind="tdcon('costgroups')">
            <span class="txtov" :title="item['cost_group_name']">
              {{ item["cost_group_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('subject')">
            <span class="txtov" :title="item['subject']">
              {{ item["subject"] }}
            </span>
          </td>

          <td v-bind="tdcon('net_amount')">
            <span class="txtov" :title="item['net_amount_cc']">
              {{ $dft.curr(item["net_amount_cc"]) }}&nbsp;
              <template>{{ item["currency_iso"] || "EUR" }}</template>
            </span>
          </td>

          <td v-bind="tdcon('status')">
            <span
              class="circle"
              :style="{
                backgroundColor: `${getInvoiceStatColor(item['status_color'])}`,
              }"
            ></span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import { getInvoiceStatColor } from '../../../accounting/models/color-status';
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import TextInput from "../../../../plugins/text-field/text-input";
import { costListLDTRoutes } from "../../../accounting/router/routes";
export default {
  components: {
    NTable,
    TextInput,
  },
  props: ["selectedAccountsDetails"],
  data: function () {
    return {
      selectedInvoice: {},
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false,
      }),
    };
  },
  computed: {
    list: function () {
      return this.selectedAccountsDetails.costs || [];
    },
    headers: function () {
      return [
        createTableHeader("main_costs"),
        createTableHeader("creditor"),
        createTableHeader("date", { mw: 100 }),
        createTableHeader("costgroups"),
        createTableHeader("subject"),
        createTableHeader("net_amount", { ta: "right", f: 0.5, minw: 120 }),
        createTableHeader("status", { ta: "center", minw: 50 }),
      ];
    },
  },
  methods: {
    getInvoiceStatColor: getInvoiceStatColor,
    addContactRelationClick: function () {},
    onRowClicked(item) {
      this.$router.push({
        name: costListLDTRoutes.names.tab,
        params: {
          invoice_id: item.invoice_id,
          tab: "overview",
        },
      });
    },
  },
};
</script>
